export default "__VITE_ASSET__d9c02f33__"